import { useEffectOnce } from 'src/lib/hooks';
import * as events from 'src/lib/events';
import { useTrackingEvent } from './useTrackingEvent';

const CHECK_TIMEOUT = 5000;

/**
 * Logic of tracking Hotjar activity:
 *   - we are giving Hotjar 5 seconds to load
 *   - fire "hotjarCheckActivity" event to understand if we even got to this point
 *   - we check `window.hj` field to understand if we even got their script loaded
 *   - then there is `window.hj.scriptLoaded` field, which gets set when Hotjar starts working
 *   - and also there is `window.hj.optOut`, which gets set, when Hotjar detects "do not track" flag and stops running
 *   - if none of these conditions are met, we fire "hotjarInactive" event
 */
export const useTrackHotjarActivity = () => {
  const trackEvent = useTrackingEvent();

  useEffectOnce(() => {
    const timeout = setTimeout(() => {
      trackEvent(events.SYSTEM.hotjarCheckActivity, null, { noAuth: true });

      if (!window.hj || !window.hj.scriptLoaded || window.hj.optOut) {
        trackEvent(events.SYSTEM.hotjarInactive, null, { noAuth: true });
      }
    }, CHECK_TIMEOUT);

    return () => {
      clearTimeout(timeout);
    };
  });
};
